import { render, staticRenderFns } from "./DetectionEmptyLink.vue?vue&type=template&id=e99b9456&scoped=true"
import script from "./DetectionEmptyLink.vue?vue&type=script&lang=js"
export * from "./DetectionEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99b9456",
  null
  
)

export default component.exports